<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  items: {
    icon: string;
    value: string | null;
    subtitle: string;
    mailtoContact?: string;
  }[];
}>();

const filteredItems = computed(() => props.items.filter((i) => !!i.value));
</script>

<template>
  <t-card>
    <t-card-title>
      <t-icon left>query_stats</t-icon>
      <h2 class="tw:text-xl">Overview</h2>
    </t-card-title>
    <div class="tw:grid tw:gap-6 tw:mt-4 tw:m-6">
      <div
        :key="i"
        v-for="(item, i) in filteredItems"
        class="tw:flex tw:items-center tw:gap-6"
      >
        <t-icon>{{ item.icon }}</t-icon>
        <div class="tw:flex tw:flex-col">
          <strong>
            {{ item.value }}
          </strong>
          <div class="tw:text-xs tw:text-gray-400 tw:dark:text-gray-500">
            <a :href="`mailto:${item.mailtoContact}`" v-if="item.mailtoContact">
              {{ item.subtitle }}
            </a>
            <div v-else>
              {{ item.subtitle }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </t-card>
</template>
